module.exports = __webpack_public_path__ + "img/Bus.be31756.svg";